export const zIndexes = {
  appBar: 1100,
  backdrop: 1200,
};
